import { render, staticRenderFns } from "./DashboardGreetings.vue?vue&type=template&id=8f663e38"
import script from "./DashboardGreetings.vue?vue&type=script&lang=js"
export * from "./DashboardGreetings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports